// «Comment travaille le CdE» — the app documenting its own operating process,
// straight from the file the CdE already maintains in the repo. Costs nothing,
// says everything.
import { ArrowLeft } from 'lucide-react';
import { useT } from '../i18n';
import { BpmnCanvas } from '../components/BpmnCanvas';
import { useEffect, useState } from 'react';
import { api } from '../api/client';

export function CdeProcessPage() {
  const { t } = useT();
  const [xml, setXml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [path, setPath] = useState('');

  useEffect(() => {
    api.getRepoIndex().then(idx => {
      const model = idx.entries.find((e: { path: string }) => e.path.endsWith('/Operationnalisation_Processus.bpmn'));
      if (!model) throw new Error('CdE process model not found');
      setPath(model.path);
      return api.getRepoFile(model.path);
    }).then(f => setXml(f.content)).catch(e => setError(e.message));
  }, []);

  return (
    <div className="fiche-page">
      <div className="cde-form-header" style={{ marginBottom: 'var(--s8)' }}>
        <button className="form-back" style={{ marginBottom: 'var(--s8)' }} onClick={() => history.back()}>
          <ArrowLeft className="icon-sm" /> {t('common.back')}
        </button>
        <h1 className="page-title">{t('shell.title.cde-process')}</h1>
        <div className="rep-path">{path}</div>
      </div>
      {error
        ? <div className="empty-state"><div className="empty-state-desc">{t('fiche.diagramError')}</div></div>
        : (
          <div className="bpmn-frame" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            <BpmnCanvas xml={xml} fill emptyMessage={t('fiche.diagramLoading')} />
          </div>
        )}
    </div>
  );
}
